import request from '@/utils/request'
export function nullPostAxios (url, val) {
  return request({
    url: url,
    method: 'post',
    data: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function nullGetAxios (url, val) {
  return request({
    url: url,
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function nullPutAxios (url, val) {
  return request({
    url: url,
    method: 'put',
    data: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function nullDeleteAxios (url) {
  return request({
    url: url, // 接口
    method: 'delete', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
